import { Divider, Typography } from "antd"

const { Title } = Typography

const DeviderTitile: React.FC<{ title: string }> = ({ title }) => {
  return (
    <Divider>
      <Title level={4}>{title}</Title>
    </Divider>
  )
}

export default DeviderTitile
